import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_6 = { class: "table table-bordered" }
const _hoisted_7 = { colspan: "3" }

import { computed, onMounted, type Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import { useResourceConstraintPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'
    import type { ResourceConstraintPageReadModel } from '@Quest/PortfolioScenarios/readmodels'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceConstraintPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))
    const resourceId = computed(() => String(route.params.resourceId ?? ''))

    const {
        runResourceConstraintPageQueryV1,
        modelResourceConstraintPageQueryV1
    } = useResourceConstraintPageQueryV1(
        workspaceId,
        tchProjectId,
        scenarioId,
        resourceId
    )

    const rm = modelResourceConstraintPageQueryV1 as Ref<ResourceConstraintPageReadModel | null>

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Resource"
        runResourceConstraintPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back to plan ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, `/#/portfolio-plan/selection/${workspaceId.value}/${tchProjectId.value}/${scenarioId.value}`]
                ])
              ]),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(rm).ResourceName), 1 /* TEXT */)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, null, -1 /* CACHED */))
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "my-5" }, null, -1 /* CACHED */)),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("th", { rowspan: "2" }, "Project", -1 /* CACHED */)),
                _cache[3] || (_cache[3] = _createElementVNode("th", { rowspan: "2" }, "Selection", -1 /* CACHED */)),
                _cache[4] || (_cache[4] = _createElementVNode("th", { rowspan: "2" }, "Start date", -1 /* CACHED */)),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(rm).ResourceName) + " [" + _toDisplayString(_unref(rm).ResourceUnit) + "] ", 1 /* TEXT */)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Requested"),
                _createElementVNode("th", null, "Committed"),
                _createElementVNode("th", null, "Planned")
              ], -1 /* CACHED */))
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Projects, (p) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: p.Id
                }, [
                  _createElementVNode("td", null, _toDisplayString(p.Name), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(p.Acceptance), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(p.StartDate), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(p.ResourceRequested), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(p.ResourceCommitted), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(p.ResourcePlanned), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})